import { ArrowRight } from "lucide-react";
import PipelineVisual from "./PipelineVisual";
import { Reveal } from "./Reveal";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-navy/10"
    >
      <div className="hero-grid pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 pb-20 pt-36 md:grid-cols-12 md:px-12 md:pb-28 md:pt-44">
        <div className="md:col-span-7">
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-rust">
              Business Analysis • Product Consulting
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">
              Turning business requirements into{" "}
              <em className="text-rust">development-ready</em> digital products.
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-navy/75 md:text-lg">
              Kaizen Labs helps startups and businesses transform ideas,
              requirements and complex workflows into structured digital
              products through Business Analysis, Product Strategy and Agile
              Delivery.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                data-testid="hero-discuss-project-btn"
                className="group inline-flex items-center gap-2 rounded-full bg-rust px-7 py-3.5 text-sm font-medium text-white transition-transform duration-300 hover:-translate-y-0.5"
              >
                Discuss Your Project
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
              </a>
              <a
                href="#projects"
                data-testid="hero-view-work-btn"
                className="inline-flex items-center rounded-full border border-navy/25 px-7 py-3.5 text-sm font-medium text-navy transition-colors duration-300 hover:border-navy hover:bg-navy hover:text-cream"
              >
                View My Work
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.4}>
            <p className="mt-12 flex items-center gap-3 text-sm text-navy/60">
              <span className="h-px w-8 bg-rust" aria-hidden="true" />
              Vikram Kundar — Business Analyst | Product Consultant · 17+ years
            </p>
          </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.25} className="md:mt-10">
            <PipelineVisual />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
